import { useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import programs from "../../data/programs";
import ProgramCard from "../common/ProgramCard";
import SectionHeading from "../common/SectionHeading";
import useReducedMotion from "../../hooks/useReducedMotion";
import "./ProgramsSection.css";

gsap.registerPlugin(ScrollTrigger);

export default function ProgramsSection() {
  const rootRef = useRef(null);
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (reducedMotion) return;
      gsap.from(".program-card", {
        scrollTrigger: { trigger: rootRef.current, start: "top 78%" },
        opacity: 0, y: 50, duration: 0.7, stagger: 0.1, ease: "power3.out",
      });
    }, rootRef);
    return () => ctx.revert();
  }, [reducedMotion]);

  return (
    <section className="programs-section section" ref={rootRef}>
      <div className="container">
        <SectionHeading
          eyebrow="Training Programs"
          title="Six ways to"
          highlight="get stronger"
          description="Every program is coached, progressive, and built around a clear outcome — pick the track that matches your goal."
        />
        <div className="programs-section__grid">
          {programs.map((program, i) => (
            <ProgramCard program={program} index={i} key={program.id} />
          ))}
        </div>
      </div>
    </section>
  );
}
